// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.report-buttons[data-v-dc1b6b26] {\n  background-color: rgb(245, 245, 245);\n  width: 215px;\n  height: 160px;\n  display: inline-block;\n}\n.report-flex[data-v-dc1b6b26] {\n  text-align: center;\n  min-width: 215px;\n}\n", ""]);
// Exports
module.exports = exports;
